import lazy from 'app/client/utilities/lazy';

export default lazy(() => import(/* webpackChunkName: "feedback/index" */ './index'));
